var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseApplication from "../../core/frontend/ts/BaseApplication";
import ExampleView from "./views/ExampleView";
import OrderDetailView from "./views/OrderDetailsView";
import BinDetailView from "@app/views/BinDetailView";
import RackDetailView from "@app/views/RackDetailView";
import UserDetailView from "@app/views/UserDetailView";
import UserCreateView from "@app/views/UserCreateView";
import CustomerDetailView from "@app/views/CustomerDetailView";
import ExampleLib from "./libs/ExampleLib";
import NavBarToggle from "./libs/NavBarToggle";
import Vue from "vue";
import CoreMapPlugin from "core/map/frontend/plugin/map";
import AiChatApp from "@app/ai-chat/ai-chat-app.vue";
import DimensioningJobCreateView from "@app/views/dimensioning/DimensioningJobCreateView";
import DimensioningView from "@app/views/dimensioning/DimensioningView";
import DimensioningJobItemSelection from "@app/views/dimensioning/DimensioningJobItemSelection";
import DimensioningSummaryView from "@app/views/dimensioning/DimensioningSummaryView";
/**
 * Customer specific application implementation
 */
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    function Application() {
        var _this = _super.call(this) || this;
        // Register a service worker
        // This is absolutely optional, but will give a nice boost
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', function () {
                navigator.serviceWorker.register('/sw.js');
            });
        }
        return _this;
        // !! VUE Stuff relocated to core/BaseApplication.ts
    }
    /** @override */
    Application.prototype.beforeVueInit = function () {
        _super.prototype.beforeVueInit.call(this);
        Vue.use(CoreMapPlugin);
        Vue.component('ai-chat-app', AiChatApp);
    };
    /**
     * All application specific views must be returned here
     */
    Application.prototype.getViews = function () {
        return {
            ExampleView: ExampleView,
            OrderDetailView: OrderDetailView,
            BinDetailView: BinDetailView,
            RackDetailView: RackDetailView,
            UserDetailView: UserDetailView,
            UserCreateView: UserCreateView,
            DimensioningJobCreateView: DimensioningJobCreateView,
            DimensioningView: DimensioningView,
            DimensioningJobItemSelection: DimensioningJobItemSelection,
            CustomerDetailView: CustomerDetailView,
            DimensioningSummaryView: DimensioningSummaryView,
        };
    };
    /**
     * All application specific libs must be returned here
     */
    Application.prototype.getLibs = function () {
        return {
            ExampleLib: ExampleLib,
            NavBarToggle: NavBarToggle,
        };
    };
    return Application;
}(BaseApplication));
export default Application;
